<template>
  <div class="home" id="main" @click.stop>
    <el-container>
      <el-header class="mantis-main-stage-header header_header__9bYHJ" style="height:50px;">
          <div style="display: flex; align-items: center;">
            <div class="header_logo__ahuhU">
              <span style="color:#fff;font-size:15px;">{{userInfo.soft_data.name?userInfo.soft_data.name:userInfo.company_introduction}}办公系统</span>
            </div>
          </div>
          <div style="display: flex; align-items: center; flex: 1 1 0%;">
            <div style="padding-left:40px;">
              <el-menu
                mode="horizontal"
                text-color="#fff"
                active-text-color="#fec66a" class="el-menu-vertical-demo" background-color="#437afa"
                :default-active="toIndex"
                @select="handleSelect">
                <span v-for="(item, index) in itemList" :key="index" style="display: inline-block;">
                <el-menu-item v-if="item.menu_name!='快手'" :index="item.route">
                  <span slot="title">{{ item.menu_name }}</span>
                </el-menu-item>
                <el-submenu active-text-color="#437afa" v-if="item.menu_name=='快手'" :index="item.route" style="width: 84px;">
                  <template slot="title">快手</template>
                  <el-menu-item index="https://tianyan.e.kuaishou.com/analysis/lanch">投放总览</el-menu-item>
                  <el-menu-item index="https://tianyan.e.kuaishou.com/element/fans">涨粉分析</el-menu-item>
                  <el-menu-item index="https://tianyan.e.kuaishou.com/analysis/crowdValue">人群价值</el-menu-item>
                  <el-menu-item index="https://tianyan.e.kuaishou.com/analysis/material-analysis">素材分析</el-menu-item>
                  <el-menu-item index="https://tianyan.e.kuaishou.com/analysis/liveList">直播数据</el-menu-item>
                  <el-submenu index="2-6">
                    <template slot="title">店铺流量</template>
                    <el-menu-item index="https://syt.kwaixiaodian.com/zones/flow/liveroom">直播间</el-menu-item>
                    <el-menu-item index="https://syt.kwaixiaodian.com/zone/flow/shortvideo">短视频</el-menu-item>
                    <el-menu-item index="https://syt.kwaixiaodian.com/zone/flow/goods">商品</el-menu-item>
                  </el-submenu>
                </el-submenu>
                </span>
              </el-menu>
            </div>
            <div class="mantis-new-stage-header-container">
              <ul class="mantis-new-stage-header-ul">
                <li v-if="userInfo.trList.cno&&userInfo.company_config&&userInfo.company_config.config_phone==1" :class="stateValue==1?'stateStyleup':'stateStyledown'">
                  <span style="color:#fff;">
                    <i class="iconfont icon-dianhua"></i>
                  </span>
                  <el-select @change="stateChange()" v-model="stateValue" :style="stateValue==1?'width:80px;color:#2bc58f;':'width:80px;color:#F56C6C;'" placeholder="请选择" size="mini">
                    <el-option label="上线" :value="1">
                      <span style="float: left;">
                        <i class="iconfont icon-shangxian" style="color:#2bc58f;"></i>
                      </span>
                      <span style="padding-left: 6px;color:#2bc58f;">上线</span>
                    </el-option>
                    <el-option label="下线" :value="2">
                      <span style="float: left;">
                        <i class="iconfont icon-xiaxian" style="color:#F56C6C;font-size: 13px;margin-left: 2px;"></i>
                      </span>
                      <span style="padding-left: 6px;color:#F56C6C;">下线</span>
                    </el-option>
                  </el-select>
                </li>
                <li v-if="userInfo.trList.cno&&userInfo.company_config&&userInfo.company_config.config_phone==1">
                  <el-input v-model="phoneCall" placeholder="输入电话" size="mini" clearable style="width:130px;"></el-input>
                  <el-button v-show="callStatus" @click="outcall()" type="success" size="mini">拨打</el-button>
                  <el-button v-show="callLoadingStatus" type="text">通话中</el-button>
                  <el-button v-show="ringoffBtn" @click="unlink()" type="danger" size="mini">挂断</el-button>

                  <el-input v-model="fenjiCall" placeholder="分机号" size="mini" clearable style="width:90px;margin-left:6px;"></el-input>
                  <el-button @click="clickFenji()" type="success" size="mini">确定</el-button>
                </li>
                <li v-if="userInfo.trList.cno && customerCall&&userInfo.company_config&&userInfo.company_config.config_phone==1">
                  <span style="color:#fff;">客户来电：</span>
                  <el-button @click="customerOutcall()" type="success" size="mini">接听</el-button>
                  <el-button @click="customerUnlink()" type="danger" size="mini">挂断</el-button>
                </li>

                <li>
                  <el-dropdown @command="handleCommand" class="header-item">
                    <div class="head-right">
                      <!-- 用户名称 -->
                      <span class="username" style="color:#fff;">{{userInfo && userInfo.name ?userInfo.name:'游客' }}</span>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                      <!-- 修改密码 -->
                      <el-dropdown-item command="a">
                        <span class="logout">
                          修改密码
                        </span>
                      </el-dropdown-item>
                      <!-- 退出登录 -->
                      <el-dropdown-item command="b" divided>
                        <span class="logout">
                          安全退出
                        </span>
                      </el-dropdown-item>
                      <el-dropdown-item command="c" divided>
                        <span class="logout">
                          {{userInfo && userInfo.ding_union_id?'已绑定钉钉':'绑定钉钉'}}
                        </span>
                      </el-dropdown-item>

                      <el-dropdown-item command="d" divided>
                        <!-- <span style="color:#fff;">最后登录地址：</span> -->
                        <el-tooltip class="item" effect="dark" :content="userInfo.login_at" placement="left">
                          <el-button type="text"  style="color:#606266">{{userInfo.last_address}}</el-button>
                        </el-tooltip>
                      </el-dropdown-item>
                      <el-dropdown-item command="e" divided>
                        <!-- <span style="color:#fff;">上班状态：</span> -->
                        <el-tooltip class="item" effect="dark" :content="userWorkInfo.ding_talk_on_work_date" placement="left">
                          <el-button type="text" style="color:#606266">{{userWorkInfo.schedule_detail}}</el-button>
                        </el-tooltip>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </li>
                <li style="color: #fff;font-size:12px;">
                  <span>版本号：</span>{{versionNumber}}
                </li>
              </ul>
            </div>
          </div>
      </el-header>
      <el-container style="height: calc(100% - 52px);">
        <!-- :width="isCollapse?'':'170px'" -->
        <el-aside v-if="activePath!='/kuaishou'" width="170px" style="background:#fff;">
          <!-- <el-radio-group v-model="isCollapse" style="margin-bottom: 20px;" size="mini">
            <el-radio-button :label="false">展开</el-radio-button>
            <el-radio-button :label="true">收起</el-radio-button>
          </el-radio-group> -->
          <!-- <p style="text-align:center;">
            <el-button @click="!isCollapse" type="text" size="mini">{{isCollapse?'展开':'收起'}}</el-button>
          </p> -->
          <SideMenu :items="items"></SideMenu>
        </el-aside>
        <el-main>
          <div class="content">
            <div class="content_head">
              <el-tabs v-model="activePath" type="card" closable @tab-click="tagsClick" @tab-remove="removeTab">
                <el-tab-pane
                  v-for="(item, index) in tagsList"
                  :key="index"
                  :label="item.title"
                  :name="item.path"
                >
                </el-tab-pane>
              </el-tabs>
            </div>
            <div class="content_info">
              <keep-alive>
                <!-- 需要缓存的视图组件 -->
                <router-view v-if="$route.meta.keepAlive"></router-view>
              </keep-alive>
              <!-- 不需要缓存的视图组件 -->
              <router-view v-if="!$route.meta.keepAlive"></router-view>
            </div>
          </div>
        </el-main>
      </el-container>
      <!-- 页面左侧二级菜单栏，和主体内容区域部分 -->
      <!-- <el-main>
        <router-view></router-view>
      </el-main> -->
    </el-container>

    <!-- 修改密码 -->
    <el-dialog title="重置密码" :visible.sync="changedialog" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="userInfo.updatePass==2?false:true">
      <el-form :model="changeform" :rules="changerules" ref="changeform">
        <!-- <el-form-item label="姓名" :label-width="formLabelWidth">
          <el-input v-model="changeform.name" :disabled="true" autocomplete="off" size="mini"></el-input>
        </el-form-item> -->
        <el-form-item label="原密码" :label-width="formLabelWidth" prop="old_password">
          <el-input type="password" v-model="changeform.old_password" autocomplete="off" size="mini" prefix-icon="el-icon-lock" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码" :label-width="formLabelWidth" prop="password">
          <el-input type="password" v-model="changeform.password" placeholder="请输入八位密码要求字母大小写和数字" autocomplete="off" size="mini" prefix-icon="el-icon-lock" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" :label-width="formLabelWidth" prop="password_confirmation">
          <el-input type="password" v-model="changeform.password_confirmation" autocomplete="off" size="mini" prefix-icon="el-icon-lock" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="userInfo.updatePass!=2" @click="resetchangeForm('changeform')" size="mini">取 消</el-button>
        <el-button type="primary" @click="submitchangeForm('changeform')" size="mini">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改密码end -->
    <!-- 版本号更新 -->
    <el-dialog title="系统版本号更新" :visible.sync="versionDialog" width="572px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <p style="margin-bottom:20px;">检测到系统版本更新,当前版本号:{{versionNumber}}，最新版本号:{{versionNumberNew}}</p>
      <p style="color:#F56C6C;">如您正在拨打电话，可点击稍后更新!</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelrenewal()" size="mini">稍后更新(每分钟提示)</el-button>
        <el-button type="primary" @click="renewal()" size="mini">更 新</el-button>
      </span>
    </el-dialog>
    <!-- 版本号更新end -->
    <!-- 新建客户 -->
    <create-customer v-if="adddialogFather" :adddialogFather="adddialogFather" :customerId="customerId" @chooseData="chooseData"></create-customer>
    <!-- 新建客户end -->
    <!-- 消息 -->
    <div @click.stop="listMessageClick()" class="divMessage" :style="spanRight?'right:24px;':'right:-31px;'">
      <img style="width:40px;" src="../assets/img/message.png">
      <span v-if="messageData" class="spanMessage">
        {{messageData}}
      </span>
      <span @click.stop="spanRightClick()" class="el-icon-arrow-right spanRight"></span>
    </div>
    <div v-if="newMessage" class="newMessage">
      <span>
        <span v-html="newMessageData.title"></span>
        <span @click="messageDetails(newMessageData)" style="color:#409EFF;cursor:pointer;">[查看]</span>
      </span>
      <span @click="newMessageClick()" style="font-size:14px;margin-left:10px;color:#409EFF;" class="el-icon-circle-close"></span>
    </div>
    <div v-if="listMessageDialog" class="listMessage" style="width:400px;">
      <!-- <div v-if="messageData" style="text-align:right;">
        <el-button @click="getoneClickRead()" type="text" size="mini">全部已读</el-button>
      </div>
      <div v-for="(item,index) in listMessage" :key="index" class="messageList" style="font-size:12px;">
        <p style="color:#fff;margin-bottom:0;">{{item.created_at}}</p>
        <p style="margin-bottom:0;">
          <span v-html="item.title"></span>
          <span v-if="item.is_read==0" style="color:#F56C6C;margin-right:4px;">[新]</span>
          <span @click="messageDetails(item)" style="color:#409EFF;cursor:pointer;">[查看]</span>
        </p>
      </div>
      <div style="text-align:center;">
        <el-button @click="moreMessage()" type="text" size="mini">更多<span class="el-icon-arrow-right"></span></el-button>
      </div> -->
      <div style="border-bottom:1px dashed #ccc;">
        <div class="dataMessage">
          <p>今日发货金额：<span>{{dataMessage.reportInfo.all_deal_money}}</span></p>
          <p>今日加粉数量：<span>{{dataMessage.reportInfo.wecom_num}}</span></p>
          <p>今日拨打量：<span>{{dataMessage.reportInfo.call_num}}</span></p>
          <p>今日接通量：<span>{{dataMessage.reportInfo.call_on_num}}</span></p>
          <p>今日通话时长：<span>{{dataMessage.reportInfo.call_total_time}}</span></p>
        </div>
      </div>
      <div style="color:#000;margin-top:10px;">
        <p @click="btnCustomer(item)" v-for="(item,index) in dataMessage.mailRes" :key="index" style="cursor:pointer;margin-bottom:10px;">
          {{item.name}}：<span style="color:#fa5151;">{{item.count}}</span>
        </p>
      </div>
    </div>
    <!-- 消息end -->
    <!-- <audio ref="audioElement">
      <source src="@/assets/audio.mp3" type="audio/mp3" />
    </audio>
    <el-button @click="playNotificationSound" ref="button"></el-button> -->
    <div @click="getcalldialogsmall()" v-if="calldialogsmall" class="divcalldialog">
      <span class="iconfont icon-dianhua" style="color:#2bc58f;"></span>
    </div>

    <customer-detail v-if="drawer" :customerId="customerId" :customerType="customerType" @chooseDataDetails="chooseDataDetails"></customer-detail>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from "vuex";
import { updatePassword,customerCallRecord,isWaitToProcess,onLineToGet,loginOut,version,mailUnreadMessageCount,mailMessageList,oneClickRead,getMailMessage,dingTalkUrl,outboundConfig,trBlack} from '@/api/api.js'
import CreateCustomer from '../components/createCustomer.vue'
import SideMenu from '@/components/sidemenu/SideMenu';
import CustomerDetail from '../components/customerDetails.vue';
import common from '../common/js/util.js';

let vm=null;
let timer=null;
ClinkAgent.setup({sipPhone: true, debug: false}, function () {
        ClinkAgent.registerListener(ClinkAgent.EventType.STATUS, function(token) {
            console.log('座席状态')
            if(token.statusMonitorValue=='离线'){
              sessionStorage.removeItem('stateValue')
              vm.$data.stateValue=2;
              vm.$store.dispatch('setcallStatus', true);
              vm.$store.dispatch('setcallLoadingStatus', false);
              vm.$store.dispatch('setringoffBtn', false);
            }
            if(token.code=='WRAPUP'||token.code=='IDLE'){//客户挂断
              vm.$store.dispatch('setcallStatus', true);
              vm.$store.dispatch('setcallLoadingStatus', false);
              vm.$store.dispatch('setcustomerCall', false);
              clearInterval(timer);
              vm.$store.dispatch('setringoffBtn', false);
              vm.getoutboundConfig();
            }
            if(token.action=='ringingIb'){//客户呼入座席响铃
              vm.$store.dispatch('setcustomerCall', true);
            }
        });
        // 座席状态
        ClinkAgent.registerListener(ClinkAgent.EventType.SIP_CONNECTED, function(token) {
          console.log('软电话连接：');
          console.log(token);
        })
        ClinkAgent.registerListener(ClinkAgent.EventType.SIP_DISCONNECTED, function (token) {
          console.log('软电话断线：');
          clearInterval(timer);
          vm.$store.dispatch('setringoffBtn', false);
          vm.getoutboundConfig();
          console.log(token);
        });
        ClinkAgent.registerListener(ClinkAgent.EventType.SIP_REGISTERED, function(token) {
          console.log('软电话注册：');
          console.log(token);
        })
        ClinkAgent.registerListener(ClinkAgent.EventType.PREVIEW_OUTCALL, function(token){
          console.log('预览外呼：');
          console.log(token);
        });
        ClinkAgent.registerListener(ClinkAgent.EventType.PREVIEW_OUTCALL_START, function(token){
          console.log('预览外呼呼叫客户：');
          console.log(token);
        });
        ClinkAgent.registerListener(ClinkAgent.EventType.PREVIEW_OUTCALL_RINGING, function(token){
          console.log('预览外呼客户响铃：');
          console.log(token);
        });
        ClinkAgent.registerListener(ClinkAgent.EventType.PREVIEW_OUTCALL_BRIDGE, function(token){
          console.log('预览外呼客户接听：');
          if(token.action='busyOb'){
            vm.$store.dispatch('setcallLoadingStatus', true);
            clearInterval(timer);
            vm.$store.dispatch('setringoffBtn', true);
            vm.getoutboundConfig();
          }
        });
        ClinkAgent.registerListener(ClinkAgent.EventType.JOIN_QUEUE, function(token){
          console.log('客户进入队列：');
          console.log(token);
        });
        ClinkAgent.registerListener(ClinkAgent.EventType.QUEUE_CALL, function(token){
          console.log('排队正在呼叫座席：');
          console.log(token);
        });
        ClinkAgent.registerListener(ClinkAgent.EventType.QUEUE_RNA, function(token){
          console.log('排队呼叫座席未应答：');
          console.log(token);
        });
        ClinkAgent.registerListener(ClinkAgent.EventType.LEAVE_QUEUE, function(token){
          console.log('客户离开队列：');
          console.log(token);
        });
        ClinkAgent.registerListener(ClinkAgent.EventType.INTERNAL_CALL_START, function(token){
          console.log('内部呼叫开始：');
          console.log(token);
        });
        ClinkAgent.registerListener(ClinkAgent.EventType.INTERNAL_CALL_BRIDGE, function(token){
          console.log('内部呼叫接听：');
          console.log(token);
        });
        ClinkAgent.registerListener(ClinkAgent.EventType.RINGING, function (token) {
          console.log('弹屏：');
          console.log(token);
        });
        ClinkAgent.registerListener(ClinkAgent.EventType.KICKOUT, function (token) {
          console.log('被踢下线：');
          console.log(token);
        });
        ClinkAgent.registerListener(ClinkAgent.EventType.BREAK_LINE, function (token) {
          console.log('断线：');
          console.log(token);
        });
        // ClinkAgent.registerListener(ClinkAgent.EventType.QUEUE_STATUS, function (token) {
        //   console.log('队列状态：');
        //   console.log(token);
        // });

        // 注册登录响应回调方法
        ClinkAgent.registerCallback(ClinkAgent.ResponseType.LOGIN, function (result) {
          console.log('登录响应回调方法：');
          console.log(result);
          if(result.code=='-1'){
            vm.$message({ duration: 2000,showClose: true,message: result.msg,type: 'error' });
          }
        });
        ClinkAgent.registerCallback(ClinkAgent.ResponseType.LOGOUT, function (result) {
          console.log('退出响应回调方法：');
          console.log(result);
        });
        ClinkAgent.registerCallback(ClinkAgent.ResponseType.PREVIEW_OUTCALL, function(event) {
          console.log('预览外呼回调方法：');
          console.log(event);
          if(event.code=='-1'){
            let customerId = localStorage.getItem('customerID');
            if(customerId){
              vm.calltrBlack(customerId);
            }
            vm.$message({ duration: 2000,showClose: true,message: event.msg,type: 'error' });
          }
        });
        ClinkAgent.registerCallback(ClinkAgent.ResponseType.PREVIEW_OUTCALL_CANCEL, function(token) {
          console.log('预览外呼取消回调方法');
          console.log(token);
        });
        ClinkAgent.registerCallback(ClinkAgent.ResponseType.UNLINK, function(token) {
          console.log("挂断回调方法");
          console.log(token);
          vm.$store.dispatch('setcalldialog', true);
          vm.$store.dispatch('setcalldialogsmall', false);
          vm.$store.dispatch('setcallLoadingStatus', false);
          clearInterval(timer);
          vm.$store.dispatch('setringoffBtn', false);
          vm.getoutboundConfig();
        });
        // ClinkAgent.registerCallback(ClinkAgent.ResponseType.UNLINK, function(token){
        //   console.log("挂断回调方法");
        //   console.log(token);
        //   this.$store.dispatch('setcalldialog', true);
        //   this.$store.dispatch('setcalldialogsmall', false);
        // });
        ClinkAgent.registerCallback(ClinkAgent.ResponseType.REFUSE, function(token){
          console.log("拒接回调方法");
          console.log(token);
          vm.$store.dispatch('setcalldialog', true);
          vm.$store.dispatch('setcalldialogsmall', false);
          vm.$store.dispatch('setcallLoadingStatus', false);
          clearInterval(timer);
          vm.$store.dispatch('setringoffBtn', false);
          vm.getoutboundConfig();
        });
        ClinkAgent.registerCallback(ClinkAgent.ResponseType.HOLD, function(token){
          console.log("保持回调方法");
          console.log(token);
        });
        ClinkAgent.registerCallback(ClinkAgent.ResponseType.UNHOLD, function(token){
          console.log("保持接回回调方法");
          console.log(token);
        });
        ClinkAgent.registerCallback(ClinkAgent.ResponseType.SIP_LINK, function(token){
          console.log("软电话接听回调方法");
          console.log(token);
        });
        ClinkAgent.registerCallback(ClinkAgent.ResponseType.SIP_UNLINK, function(token){
          console.log("软电话挂断回调方法");
          console.log(token);
          vm.$store.dispatch('setcalldialog', true);
          vm.$store.dispatch('setcalldialogsmall', false);
          vm.$store.dispatch('setcallLoadingStatus', false);
          clearInterval(timer);
          vm.$store.dispatch('setringoffBtn', false);
          vm.getoutboundConfig();
        });
});

export default {
  components: {
    CreateCustomer,SideMenu,CustomerDetail
  },
  // 定义属性
  data() {
    var validatePass1 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.changeform.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      itemList: [    // 水平一级菜单栏的菜单
        // { path: '/Home', title: '首页' },
      ],
      items: [],
      stateValue:2,
      phoneCall:'',
      fenjiCall:'',
      isCollapse:false,
      collapsed: false,
      QRCodeImage: "张三",
      activePath: "",
      menulist: [],
      changedialog:false,//修改密码
      formLabelWidth:'120px',
      changeform:{
        id:'',
        token:'',
        name:'',
        password:'',
        password_confirmation:'',
      },
      changerules: {
        old_password: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        password_confirmation: [
          { required: true,validator: validatePass1, trigger: 'blur' }
        ],
      },//修改密码end
      adddialogFather:false,
      customerId:'',
      tagsList:[],
      versionNumber:'',
      versionNumberNew:'',
      versionInterval:null,
      versionDialog:false,
      messageData:0,
      newMessage:false,
      newMessageData:{},
      listMessageDialog:false,
      listMessage:[],
      dataMessage:{},
      spanRight:true,
      drawer: false,
      customerId:'',
      customerType:'',
      outboundvalue:'',
    };
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    document.title = this.userInfo.soft_data.name?this.userInfo.soft_data.name+'办公系统':this.userInfo.company_introduction+'办公系统';
    const rightList=this.$store.state.rightList||JSON.parse(localStorage.getItem('rightList'));
    this.itemList=rightList;
    let path='/'+this.$route.path.split('/')[1];
    let dataId =this.itemList.findIndex((v) => {
      return v.route == path;
    });
    this.items=this.itemList[dataId].children;
    this.getversion();
    this.versionNumberManage();
    if(this.userInfo&&this.userInfo.updatePass){
      if(this.userInfo.updatePass==2){
        this.changeform.name=this.userInfo.name;
        this.changeform.id=this.userInfo.id;
        this.changedialog=true;
      }
    }
    vm=this;
    this.activePath = localStorage.getItem("activePath")&&localStorage.getItem("activePath")!='undefined'?localStorage.getItem("activePath"):'';
    this.menulist = this.rightList;
    if(localStorage.getItem('settagsList')&&localStorage.getItem('settagsList')!='undefined'){
      this.tagsList=JSON.parse(localStorage.getItem('settagsList'))
    }
    if(sessionStorage.getItem('iframeUrl')&&sessionStorage.getItem('iframeUrl')!='undefined'){
      this.$store.dispatch('setiframeUrl', sessionStorage.getItem('iframeUrl'));
    }
    //消息
    this.getmailUnreadMessageCount();
    this.getoutboundConfig();
    this.getmailMessageList();
  },
  beforeDestroy () {
    document.getElementById("main").removeEventListener('click', this.bodyCloseMenus)
  },
  computed: {
    ...mapState(['rightList','userInfo','callStatus','ringoffBtn','iframeUrl','callLoadingStatus','customerCall','userWorkInfo','calldialogsmall']),
    showTags() {
      return this.tagsList.length > 0;
    },
    toIndex(){  // 根据路径绑定到对应的一级菜单，防止页面刷新重新跳回第一个
      return '/' + this.$route.path.split('/')[1];
    },
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that=this;
    this.stateValue=sessionStorage.getItem('stateValue')?parseInt(sessionStorage.getItem('stateValue')):2;
    if(this.stateValue===1){
      setTimeout(function(){
        that.online();
      },5000);
    }
    let name = this.$store.state.userInfo && this.$store.state.userInfo.name ? this.$store.state.userInfo.name : '请先登录';
    let phone = this.$store.state.userInfo && this.$store.state.userInfo.phone ? this.$store.state.userInfo.phone : '请先登录';

    this.$watermark.set('芬森医疗-' + name + phone +'-' + common.dateFormat('YYmmdd', new Date()));
    // 消息
    document.getElementById("main").addEventListener('click', this.bodyCloseMenus);
    if (typeof (EventSource) !== 'undefined') {
        const sourc = new EventSource(this.$store.state.resquest+'/api/mail/realTimeMessagePush?token='+localStorage.getItem('token')); // 后端接口，要配置允许跨域属性
        sourc.onopen=function(e){
        }
        sourc.onmessage=function(e){
          let data=JSON.parse(e.data);
          // that.messageData++;
          if(data.eject==1){
            that.newMessage=true;
            that.newMessageData=data;
            setTimeout(function() {
              that.newMessage=false;
              that.newMessageData={};
            }, 3000);
          }
        }
        sourc.onerror=function(e){
        }
    } else {
      that.$message.error('当前浏览器不支持服务器发送的事件');
    }
  },
  // 监控data中的数据变化
  watch: {
    // 对router进行监听，每当访问router时，对tags的进行修改
    $route(newValue) {
      this.activePath = newValue.path;
      localStorage.setItem("activePath", this.activePath);

      let path='/'+newValue.path.split('/')[1];
      let dataId =this.itemList.findIndex((v) => {
        return v.route == path;
      });
      this.items=this.itemList[dataId].children;

      this.setTags(newValue);
      this.getversion();
      this.getmailUnreadMessageCount();
    }
  },
  // 方法集合
  methods: {
    handleSelect(path){  // 切换菜单栏
      if(path.substring(0,5)=='https'){
        this.$store.dispatch('setiframeUrl', path);
        if(this.activePath != '/kuaishou'){
          this.$router.push({
            path: '/kuaishou'
          });
        }
      }else{
      let dataId =this.itemList.findIndex((v) => {
        return v.route == path;
      });
      this.items=this.itemList[dataId].children;

      this.$router.push({
        path: path
      });
      }
    },
    playNotificationSound() {
      const audioElement = this.$refs.audioElement;
      audioElement.play();
    },
    spanRightClick(){
      this.spanRight=false;
      this.listMessageDialog=false;
    },
    newMessageClick(){
      this.newMessage=false;
    },
    listMessageClick(){
      this.listMessageDialog=!this.listMessageDialog;
      this.spanRight=true;
      if(this.listMessageDialog){
        this.getmailMessageList();
      }
    },
    bodyCloseMenus (e) {
      const self = this;
      if (self.listMessageDialog === true){
        self.listMessageDialog = false;
      }
    },
    btnCustomer(data){
      this.$store.dispatch('setcustomerId', data.customer_ids);
      this.$store.dispatch('setcustomerSearchType', data.is_deal);
      if(this.$route.path=='/scrm/customerList'){
        this.$router.go(0);
      }else{
        this.$router.push({path:'/scrm/customerList'});
      }
    },
    //最新消息条数
    getmailUnreadMessageCount(){
      mailUnreadMessageCount().then(res => {
        if(res.data.code==200){
          // this.messageData=res.data.data.unreadCount;
        }
        else{
          this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
        }
      });
    },
    //消息列表
    getmailMessageList(){
      mailMessageList({bell:1}).then(res => {
        if(res.data.code==200){
          this.dataMessage=res.data.data;
          this.dataMessage.reportInfo.call_total_time=res.data.data.reportInfo.call_total_time?this.convertMinutes(res.data.data.reportInfo.call_total_time):'';
          this.messageData=res.data.data.mailCount;
        }
        else{
          this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
        }
      });
    },
    convertMinutes(minutes) {
      const hours = Math.floor(minutes / 60);  // 计算小时
      const remainingMinutes = Math.floor(minutes % 60);   // 计算剩余的分钟
      const seconds = Math.floor((minutes % 1) * 60);  // 将分钟的小数部分转换为秒
      return `${hours}小时 ${remainingMinutes}分钟 ${seconds}秒`;
    },
    //消息详情
    messageDetails(data){
      let customer=data.custom;
      getMailMessage({id:data.id}).then(res => {
        if(res.data.code==200){
          if(data.type==1||data.type==4||data.type==5){
            this.customerId=customer.customer_id;
            this.customerType='';
            this.drawer=true;
          }
          this.getmailUnreadMessageCount();
        }
      });
    },
    //一键已读
    getoneClickRead(){
      oneClickRead().then(res => {
        if(res.data.code==200){
          this.getmailUnreadMessageCount();
          this.getmailMessageList();
          this.$message({ duration: 2000,showClose: true,message: '一键已读成功',type: 'success' });
        }
        else{
          this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
        }
      });
    },
    moreMessage(){
      if(this.$route.path!='/scrm/messageManagement'){
        this.activePath = '/scrm/messageManagement';
        localStorage.setItem("activePath", '/scrm/messageManagement');
        this.$router.push({path:'/scrm/messageManagement'});
      }
    },

    getversion(){
      version().then(res => {
        if(res.data.code==200){
          if(localStorage.getItem('versionNumber') != res.data.data.version){
            this.versionNumberNew= res.data.data.version;
            this.versionDialog=true;
          }else{
          }
        }else{
        }
      });
    },
    addcustomer(){
      this.adddialogFather=true;
    },
    chooseData(){
      this.adddialogFather=false;
    },
    handleNavState(activePath) {
      this.activePath = activePath;
      localStorage.setItem("activePath", activePath);
    },
    handleLogout() {
      loginOut({}).then(res => {
        if(res.data.code==200){
          localStorage.removeItem('user_info')
          localStorage.removeItem('token')
          localStorage.removeItem('rightList')
          localStorage.removeItem('settagsList')
          localStorage.removeItem('activePath')
          sessionStorage.removeItem('stateValue')
          sessionStorage.removeItem('searchformbox');
          // localStorage.setItem('originSign','');
          // this.$store.dispatch('setpasswordLogin', true);
          //下线
          this.offline()
          window.location.reload()
          this.$router.push('/login')
        }else{
          this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
        }
      });
    },
    handleCommand(command){
      if(command=='a'){
        this.changePassword();
      }else if(command=='b'){
        this.handleLogout();
      }else if(command=='c'){
        if(!this.userInfo.ding_union_id){
          this.bindDing();
        }
      }
    },
    bindDing(){
      var url = this.$store.state.dingdingurl;
      let para = {
        redirect_uri:url,
        type:2,
        token:this.userInfo.token
      }
      dingTalkUrl(para).then(res => {
        if(res.data.code == 200){
          window.location.href = res.data.data;
        }
      })
    },
    //修改密码
    changePassword(){
      this.changeform.name=this.userInfo.name;
      this.changeform.id=this.userInfo.id;
      this.changedialog=true;
    },
    submitchangeForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm('此操作将修改该用户密码, 是否继续?', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(() => {
            let parmas = this.changeform;
            parmas.token=localStorage.getItem('token')|| '';
            updatePassword(parmas).then(res => {
              if(res.data.code==200){
                this.changedialog=false;
                this.$message({ duration: 2000,showClose: true,message: '修改密码成功',type: 'success' });
                this.$refs[formName].resetFields();
                localStorage.removeItem('user_info')
                localStorage.removeItem('token')
                localStorage.removeItem('rightList')
                localStorage.removeItem('settagsList')
                localStorage.removeItem('activePath')
                sessionStorage.removeItem('stateValue')
                sessionStorage.removeItem('searchformbox')
                // localStorage.setItem('originSign','');
                // this.$store.dispatch('setpasswordLogin', true);
                //下线
                this.offline()
                window.location.reload()
                this.$router.push('/login')
              }else{
                this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
              }
            });
          }).catch(() => {
            this.$message({ duration: 2000,showClose: true,type: 'info',message: '已取消修改密码'});
          });
        } else {
          return false;
        }
      });
    },
    resetchangeForm(formName) {
      this.changedialog=false;
      this.$refs[formName].resetFields();
    },
    //修改密码end
    //状态修改
    stateChange(){
      if(this.stateValue==1){
        //上线
        this.online();
        onLineToGet().then(res => {
          if(res.data.code == 200){
          }else{
            this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
          }
        })
      }else{
        //下线
        this.offline()
      }
    },
    //上线
    online(){
      if(!this.userInfo.trList.bindTel){
        this.$message({ duration: 2000,showClose: true,message: '请先绑定天润座席',type: 'error' });
        return;
      }
      var params = {};
      params.identifier = this.userInfo.trList.tr_identifier;
      params.loginStatus = 1;
      params.bindType = 3;
      params.cno = this.userInfo.trList.cno;
      params.bindTel = this.userInfo.trList.bindTel;
      params.password = this.userInfo.trList.tr_password;
      ClinkAgent.login(params);
      sessionStorage.setItem('stateValue',1);
    },
    //下线
    offline(){
      var params = {};
      params.logoutMode = 1;
      params.removeBinding = 0;
      ClinkAgent.logout(params);
      sessionStorage.setItem('stateValue',2);
    },
    //拨打
    outcall(){
      if(this.stateValue==1){
        isWaitToProcess({phone:this.phoneCall}).then(res=>{
          if(res.data.code==200){
            if(res.data.data.isHave){
              this.$message({ duration: 2000,showClose: true,message: '您有待处理的客户，请先处理！',type: 'error' });
            }else{
              let that = this;
              customerCallRecord({user_id:that.userInfo.id,phone:that.phoneCall}).then(res => {
                if(res.data.code==200){
                  var phone = that.phoneCall;
                  var params = {};
                  params.tel = phone;
                  params.requestUniqueId = res.data.data.customer_record_id;
                  ClinkAgent.previewOutcall(params);
                  that.$store.dispatch('setcallStatus', false);

                  that.outboundvalue--;
                  that.$store.dispatch('setringoffBtn', false);
                  timer = setInterval(function(){
                    if(that.outboundvalue>1){
                      that.outboundvalue--;
                    }else{
                      clearInterval(timer)
                      that.$store.dispatch('setringoffBtn', true);
                      that.getoutboundConfig();
                    }
                  },1000);
                }else{
                  that.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
                }
              });
            }
          }else{
            this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
          }
        })
      }else{
        this.$message({ duration: 2000,showClose: true,message: '未上线，请先上线再拨打！',type: 'error' });
      }
    },
    // 拨打电话-黑名单或非白名单状态(客户详情拨打)
    calltrBlack(customer_id){
      trBlack({customer_id:customer_id}).then(res => {
        if(res.data.code==200){}
        else{
          this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
        }
      });
    },
    //挂断
    unlink(){
      ClinkAgent.sipUnlink();
      this.$store.dispatch('setcallStatus', true);
      this.$store.dispatch('setcallLoadingStatus', false);
      this.$store.dispatch('setringoffBtn', false);
      clearInterval(timer)
      this.getoutboundConfig();
    },
    //分机号
    clickFenji(){
      // var fenji = $("#fenji").val();
      var params = {digits:this.fenjiCall,direction:'out'};
      // params.digits = fenji;
      // params.direction = 'out';
      ClinkAgent.dtmf(params);
    },
    customerOutcall(){
      ClinkAgent.sipLink();
    },
    customerUnlink(){
      ClinkAgent.sipUnlink();
      this.$store.dispatch('setcustomerCall', false);
    },
    //拨打电话
    getmailUnreadMessageCount(){
      mailUnreadMessageCount().then(res => {
        if(res.data.code==200){
          // this.messageData=res.data.data.unreadCount;
        }
        else{
          this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
        }
      });
    },

    isActive(path) {
      return path === this.$route.fullPath;
    },
    toURL(url){
      this.activePath = url;
      localStorage.setItem("activePath", this.activePath);
      this.$router.push(url);
    },
    // 关闭单个标签
    closeTags(index) {
      const delItem = this.tagsList.splice(index, 1)[0];
      const item = this.tagsList[index] ? this.tagsList[index] : this.tagsList[index - 1];
      if (item) {
        delItem.path === this.$route.fullPath && this.$router.push(item.path);
      } else {
        this.$router.push('/');
        this.show=false;
      }
    },
    removeTab(targetName) {
        let tabs = this.tagsList;
        // let activeName = this.tagsListValue;
        let activeName = this.activePath;
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.path === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.path;
              }
            }
          });
        }

        // this.tagsListValue = activeName;
        this.activePath = activeName;
        localStorage.setItem("activePath", this.activePath);
        this.tagsList = tabs.filter(tab => tab.path !== targetName);
        this.$router.push(this.activePath)
    },
    tagsClick(tab, event){
      this.$router.push(tab.name)
    },
    // 设置标签
    setTags(route) {
      //用some判断当前监听路由路径是否是tagsList其中一个
      //some如果回调函数中有任意一个满足条件，则返回true；否则为false。
      const isExist = this.tagsList.some(item => {
        return item.path === route.path;
      })
      //如果tagsList其中没有就添加进去
      if(!isExist && this.tagsList) {
        this.tagsList.push({
          title: route.meta.title,
          path: route.path,
          name: route.meta.title
        });
        localStorage.setItem('settagsList',JSON.stringify(this.tagsList))
      }
    },
    //版本管理
    versionNumberManage(){
      let that=this;
      that.versionNumber=localStorage.getItem('versionNumber');
      that.versionInterval = setInterval(function(){
          version().then(res => {
            if(res.data.code==200){
              if(localStorage.getItem('versionNumber') != res.data.data.version){
                that.versionNumberNew= res.data.data.version;
                that.versionDialog=true;
                clearInterval(that.versionInterval);
              }else{
                // clearInterval(that.versionInterval);
              }
            }else{
              clearInterval(that.versionInterval);
            }
          });
      }, 6000*10);
    },
    renewal(){
      localStorage.setItem("versionNumber", this.versionNumberNew);
      this.versionDialog=false;
      this.$router.go(0);
    },
    cancelrenewal(){
      this.versionDialog=false;
      this.versionNumberManage();
    },
    getcalldialogsmall(){
      this.$store.dispatch('setcalldialog', true);
      this.$store.dispatch('setcalldialogsmall', false);
    },
    //客户详情
    chooseDataDetails(){
      this.drawer=false;
    },
    getoutboundConfig(){
      outboundConfig().then(res => {
        if(res.data.code==200){
          this.outboundvalue=Number(res.data.data)+1;
        }else{
          this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
        }
      });
    },
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
};
</script>

<style lang="scss" scoped>
  .home {
    width: 100%;
    height: 100%;
    position:relative;
    .el-header {
      height: 52px;
      padding: 0;
      line-height: unset;
      // background: #262f3e;
      background: #437afa;
      .el-menu-item{
        font-size:13px;
        padding: 0 24px;
        // margin:0 6px;
        height:50px;
        line-height:50px;
      }
      .el-button{
        font-size: 13px;
      }
      .el-dropdown{
        font-size: 13px;
      }
      .el-button--success {
        background-color: #437afa !important;
        border-color: #fff !important;
        color: #fff;
      }
      .is-active .el-submenu__title{
        color:#437afa !important;
        background-color: #e7eefe !important;
      }
    }
    .el-container {
      width: 100%;
      height: 100%;
      // height: calc(100% - 52px);
      .el-aside{
        .el-menu{
          border: 0px ;
        }
      }
      .el-main{
        padding: 0px;
        background: rgb(242, 245, 248);
        .content{
          width: 100%;
          height: 100%;
          .content_head{
            width: 100%;
            height: 40px;
            border-bottom: 1px solid rgba(233, 233, 233, 1);
            position: relative;
            .title{
              box-sizing: border-box;
              color: #606266;
              font-size: 14px;
              padding: 7px 30px;
              background-color: #f2f5f8;
              position: absolute;
              left: 0px;
              bottom: 0px;
            }
          }
          .content_info{
            box-sizing: border-box;
            width: 100%;
            height: calc(100% - 60px);
            // padding: 20px;
          }
        }
      }
      .el-submenu__title{
        height:50px;
        line-height:50px;
      }
    }
    div .is-active{
      color:#437afa !important;
      // background-color: #fff !important;
      background-color: #e7eefe !important;
      border-bottom: 2px solid rgb(254,198,106);
    }
  }
  @media (max-width: 1000px) {
    .home {
      width: 1380px;
    }
  }
  .header_header__9bYHJ {
    // box-shadow: 4px 4px 40px 0 rgb(0 0 0 / 5%);
    position: relative;
    display: flex;
    align-items: center;
    height: 47px;
    background-color: #2b3d48;
    z-index: 1000;
    width: 100%;
    padding: 0;
  }
  .header_header__9bYHJ .header_logo__ahuhU {
    margin-left: 20px;
  }
  .header_header__9bYHJ .header_logo__ahuhU img {
    width: 205px;
    height: 43px;
  }
  .mantis-main-stage-header .mantis-new-stage-header-container {
    display: flex;
    flex: 1 1;
    justify-content: flex-end;
  }
  .mantis-main-stage-header .mantis-new-stage-header-ul {
    margin-bottom: 0;
    padding-right:20px;
    font-size: 14px;
  }
  .mantis-main-stage-header .mantis-new-stage-header-ul li {
    display: inline-block;
    vertical-align: middle;
  }
  .mantis-main-stage-header .mantis-new-stage-header-ul li:not(:empty) {
    margin-right: 12px;
  }

  .tags {
    position: relative;
    height: 50px;
    overflow: hidden;
    background: white;
    padding-right: 120px;
  }
  .tags ul {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
  }
  .tags-li {
    float: left;
    margin: 3px 5px 2px 3px;
    border-radius: 3px;
    font-size: 15px;
    overflow: hidden;
    cursor: pointer;
    height: 30px;
    line-height: 23px;
    border: 1px solid #e9eaec;
    background: #fff;
    padding: 0 5px 0 12px;
    vertical-align: middle;
    color: #666;
    -webkit-transition: all .3s ease-in;
    -moz-transition: all .3s ease-in;
    transition: all .3s ease-in;
  }
  .tags-li:not(.active):hover {
    background: #f8f8f8;
  }
  .tags-li-title {
    float: left;
    max-width: 80px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-right: 5px;
    color: #666;
  }
  .tags-li.active {
    color: #fff;
    border: 1px solid #10B9D3;
    background-color: #67C23A;
  }
  .tags-li.active .tags-li-title {
    color: #fff;
  }
  .tags-close-box {
    position: fixed;
    right: 0;
    top: 50px;
    box-sizing: border-box;
    padding-top: 1px;
    text-align: center;
    z-index: 10;
  }
  .messageList{
    padding:2px 0;
  }
  .messageList:not(:last-child){
    border-bottom:1px dashed #ccc;
  }
  .divMessage{
    position:fixed;
    // top:80px;
    bottom:80px;
    right:24px;
    border-radius: 50%;
    border: 1px solid #40C4FF;
    width: 62px;
    height: 62px;
    text-align: center;
    line-height:58px;
    background:#D8E9FF;
    z-index:9999999;
    cursor: pointer;
  }
  .spanMessage{
    position:absolute;
    width:24px;
    height:24px;
    line-height:24px;
    border-radius: 50%;
    color:#fff;
    background:#F56C6C;
    font-size:12px;
    top:0;
    left:-8px;
  }
  .spanRight{
    position:absolute;top:0;right:-16px;line-height:62px;color:#40C4FF;cursor: pointer;
  }
  .newMessage{
    position:fixed;
    top:80px;
    right:100px;
    background:#D8E9FF;
    border:1px solid #40C4FF;
    padding:4px;
    font-size:12px;
    border-radius:4px;
    z-index:9999999;
  }
  .listMessage{
    position:fixed;
    // top:142px;
    bottom:142px;
    right:24px;
    background:#D8E9FF;
    border:1px solid #40C4FF;
    padding:10px;
    font-size:12px;
    border-radius:4px;
    z-index:9999999;
  }
  .dataMessage{
    display:grid;
    grid-template-columns:repeat(2,50%);
    color:#000;
  }
  .dataMessage p{
    margin-bottom:10px;
    cursor: pointer;
  }
  .dataMessage span{
    color:#fa5151;
  }

  .divcalldialog{
    position:fixed;
    top: 170px;
    right:24px;
    border-radius: 50%;
    border: 1px solid #40C4FF;
    width: 40px;
    height: 40px;
    text-align: center;
    line-height:38px;
    background:#D8E9FF;
    z-index:9999999;
    cursor: pointer;
  }
</style>
<style>
.el-menu{
  border-right:0;
}
.el-submenu .el-menu-item{
  min-width: 100%;
}
.el-menu--horizontal > .el-menu-item{
  height: 50px !important;
  line-height: 50px !important;
}
/* .el-submenu__title i{
  color:#000;
} */
  .mantis-new-stage-header-ul .el-input__inner{
    /* background-color: #444A54;
    border:1px solid #444A54; */
    background-color: #fff;
    border:1px solid #fff;
    color: #437afa;
  }
  .mantis-new-stage-header-ul .stateStyleup .el-input__inner{
    color:#437afa;
  }
  .mantis-new-stage-header-ul .stateStyledown .el-input__inner{
    color:#F56C6C;
  }
  .mantis-main-stage-header .el-dropdown{
    color:rgb(193, 198, 200);
  }
  .el-menu-vertical-demo .el-menu-item-group__title{
    padding:0;
  }
  .home .el-header .el-menu-item{
    height: 50px !important;
    line-height: 50px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/home1.vue